$(document).ready(function () {
    $(".space-form .close").click(function (e) {
        e.preventDefault();
        $(".space-form").removeClass("space-form-active");
    });

    $(".space-form .read-more-btn.bg-black").click(function (e) {
        e.preventDefault();
        $(".space-form").removeClass("space-form-active");
    });

    $("#product_enquiry_form").click(function (e) {
        e.preventDefault();
        $(".popup_form").addClass("popup_form_active");
    });

    $(".popup_form .close-button").click(function (e) {
        e.preventDefault();
        $(".popup_form").removeClass("popup_form_active");
    });



    // product form function
    let pName = $("#product__name").text().replace(/ /g, '');
    // console.log(pName);

    $("#product_select").val(pName);

    let pImage = $("#form_image img").attr("src");
    console.log(pImage);

    $(".popup_form .product-body .product-image img").attr("src", pImage)


});